import { render } from "./ToolbarImages.vue?vue&type=template&id=75d71324&ts=true"
import script from "./ToolbarImages.vue?vue&type=script&lang=ts"
export * from "./ToolbarImages.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Pablo\\Documents\\Programacion\\Playas\\beachguard_v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__